import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const MaturityIndicesDetailReport = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/standardreport");
  };

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const FillReport = (employeeId,farmActivityId) => {
    var d = new Date(selectedToDate);
    setCurrentPage(1);
    d.setDate(d.getDate() + 1);

  
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = `&fieldExecutiveId=${employeeId}`;
    }

 

    if (farmActivityId > 0) {
      urlfilter = urlfilter + `&farmActivityId=${farmActivityId}`;
    }

    var url = `/api/maturityIndicesReportMIS/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        //console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getFiedlActivity } = useHttp();
  useEffect(() => {
    getFiedlActivity(
      {
        url: `/api/farmActivity/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("farmActivity", data);

        setFarmActivityData(data);
      }
    );
  }, [getFiedlActivity]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=CommercialFarming&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        // //console.log("emp",data.output )
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
       
      }
    );
  }, [getEmp]);


  const fieldsToExport = [
    "observationDate",
    "maturityIndicesNo",
    "farmManager",
    "plotName",
    "plotArea",
    "plotAreaUnit",
    "cropName",
    "varietyName",
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Farm Manager",
    "Plot Name",
    "Plot Area",
    "Unit",
    "Crop Name",
    "Variety Name",
    "Computational Method (DFFB)",
  ];

  const handleExportExcel = () => {
    const filename = "MaturityIndicesReport.xlsx";
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Maturity Indices Detail Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <hr />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Activity </label>
                  <select
                    id="fieldActivityId"
                    className="form-control"
                    value={farmActivityId}
                    onChange={(e) => {
                      setFarmActivityId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {farmActivityData &&
                      farmActivityData.map((x) => (
                        <option
                          key={x.fieldActivityId}
                          value={x.fieldActivityId}
                        >
                          {x.fieldActivityName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, farmActivityId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Date </th>
                          <th> Doc No </th>
                          <th>Farm Manager</th>
                          <th>Plot Name </th>
                          <th> Plot Area </th>
                          <th> Unit </th>
                          <th> Crop Name </th>
                          <th>Variety Name </th>
                          <th colSpan={2}>Computational Method</th>
                          <th colSpan={11}>Physical Method</th>
                          <th colSpan={9}>Chemical Method</th>
                        </tr>
                        <tr className="table-header">
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>DFFB</th>
                          <th>Heat Unit</th>
                          <th>Color</th>
                          <th>Weight</th>
                          <th>Weight Unit</th>
                          <th>Fruit Size</th>
                          <th>Fruit Size Unit</th>
                          <th>Specific Gravity</th>
                          <th>Surface Strength</th>
                          <th>Firmness Test</th>
                          <th>Firmness Test Unit</th>
                          <th>Fruit Retention Strength</th>
                          <th>Development of Abscision Layer</th>
                          <th>Dry Matter</th>
                          <th>Starch Content</th>
                          <th>Sugar Content</th>
                          <th>Acid Content</th>
                          <th>Juice Content</th>
                          <th>Oil Content</th>
                          <th>Moisture Content</th>
                          <th>TSS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            const parseJSON = (str) => {
                              try {
                                return JSON.parse(str.replace(/'/g, '"'));
                              } catch (e) {
                                return {};
                              }
                            };

                            const computational = parseJSON(
                              itm.computationalMethod
                            );
                            const physical = parseJSON(itm.physicalMethod);
                            const chemical = parseJSON(itm.chemicalMethod);

                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.observationDate}</td>
                                <td>{itm.maturityIndicesNo}</td>
                                <td>{itm.farmManager}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.plotArea}</td>
                                <td>{itm.plotAreaUnit}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                <td>{computational.dffb}</td>
                                <td>{computational.heatUnit}</td>
                                <td>{physical.color}</td>
                                <td>{physical.weight}</td>
                                <td>{physical.weightUnit}</td>
                                <td>{physical.fruitSize}</td>
                                <td>{physical.fruitSizeUnit}</td>
                                <td>{physical.specificGravity}</td>
                                <td>{physical.surfaceStrength}</td>
                                <td>{physical.firmnessTest}</td>
                                <td>{physical.firmnessTestUnit}</td>
                                <td>{physical.fruitRetentionStrength}</td>
                                <td>{physical.developmentOfAbscissionLayer}</td>
                                <td>{chemical.dryMatter}</td>
                                <td>{chemical.starchContent}</td>
                                <td>{chemical.sugerContent}</td>
                                <td>{chemical.acidContent}</td>
                                <td>{chemical.juiceContent}</td>
                                <td>{chemical.oilContent}</td>
                                <td>{chemical.moistureContent}</td>
                                <td>{chemical.tss}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MaturityIndicesDetailReport;
